import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "react-bootstrap";
import { Image } from "antd";
import { DB_POSTFIX, getFileLiveUrl } from "../../utils";
import axios from "axios";
import { ServiceUrl } from "../../utils/serviceUrl";
import PsContext from "../../context";
import ImageGallery from "react-image-gallery";

const PopupGallery = (props) => {
  const context = useContext(PsContext);
  const [image, setImage] = useState([]);

  useEffect(() => {
    loadData();
  }, [props.dataSource]);

  const loadData = () => {
    axios
      .get(
        ServiceUrl.LIST_GALLERY +
          "?sadb=" +
          DB_POSTFIX +
          "&all=1" +
          "&category=" +
          props.dataSource.category
      )
      .then((res) => {
        if (res["data"].status == "1") {
          setImage(res["data"].data);
        }
      });
  };

  const getImages = () => {
    let rv = [];
    image.map((item, i) => {
      rv.push({
        original: getFileLiveUrl(item.feature_image),
        thumbnail: getFileLiveUrl(item.feature_image),
      });
    });
    return rv;
  };

  return (
    <div>
      <Modal title="gallery" show={props.view} size="xl">
        <ModalHeader>
          <Col md={9}>
            {image.length > 0 && (
              <h6
                style={{
                  color: `${context.settingValue("web_site_header_textcolor")}`,
                }}
                className="fw-bold mt-2"
              >
                <i class="fa-solid fa-angles-right me-2"></i>
                {image[0].title}
              </h6>
            )}
          </Col>
          <Col md={3} className="text-end">
            <Button
              style={{
                backgroundColor: `${context.settingValue(
                  "web_site_header_bgcolor"
                )}`,
              }}
              onClick={props.onHide}
            >
              X
            </Button>
          </Col>
        </ModalHeader>

        <ModalBody>
          <Row>
            {/* Slider */}

            {context.settingValue("web_site_single_gallery_viewtype") ==
              "slider" &&
              image &&
              image.length > 0 && (
                <Col md={12}>
                  <ImageGallery items={getImages()} />;
                </Col>
              )}

            {/* Slider */}

            {/* Card */}

            {context.settingValue("web_site_single_gallery_viewtype") ==
              "card" &&
              image &&
              image.map((item, index) => (
                <Col md={3} key={index} className="mt-2">
                  <div className="card">
                    <Image
                      className="w-100 rounded"
                      height="200px"
                      src={getFileLiveUrl(item.feature_image)}
                    />
                  </div>
                </Col>
              ))}

            {/* Card */}
            {/* {image &&
              image.map((item, i) => (
                <Col md={3} className="mt-3">
                  <Image
                    className="materialboxed rounded"
                    height="200px"
                    width="250px"
                    data-caption="Education master image captions"
                    src={getFileLiveUrl(item.feature_image)}
                    alt=""
                  />
                </Col>
              ))} */}
          </Row>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default PopupGallery;
